<template>
  <div class="panel-card card-lg clearfix">
    <div v-if="payAnomalyLoading">
      <Spinner />
    </div>
    <div v-else-if="payAnomalyModifiedData.length" class="bg-white px-20 py-20">
      <Row class="position-relative">
        <div class="f-left">
          <h3> {{ $t('INDENT_CHARGE_LEVEL_ANOMALIES') }} </h3>
        </div>
        <div class="f-right" v-if="$hasPermission('approve_retrigger_payments')">
          <Button type="primary" @click="approvePayment">
            {{$t('INDENT_APPROVE_PAYMENT_GENERATION') }}
          </Button>
        </div>
      </Row>
      <Row class="position-relative mt-10">
        <Collapse v-model="activeTab" accordion class="collapse-slider">
          <CollapseItem v-for="(data, index) of payAnomalyModifiedData"
            :title="data.order_reference"
            :key="index"
            :name="index">
            <Row class="position-relative">
              <Col :span="24">
                <Table
                  :data="data.charges"
                  class="table-fixed expand-icon"
                  row-key="id"
                  border
                  default-expand-all
                  style="width: 100%">
                  <Table-column fixed prop="key" :label="$t('INDENT_ANOMALY_TYPE')" width="300" />
                  <Table-column prop="actual_value" :label="$t('INDENT_ACTUAL')" width="220" />
                  <Table-column prop="variance" :label="$t('INDENT_VARIANCE')" width="200" />
                </Table>
              </Col>
            </Row>
          </CollapseItem>
        </Collapse>
      </Row>
    </div>
    <div v-else
      class="status-msg my-sm" size="small" text="top-left" style="width:45%;">
      <div class="status-content">
        <span class="status-inner">
          <img :src="NoData" width="200" height="180" class="img-responsive" alt=""/>
          <p style="width:100px; left:20px;">{{ $t('INDENT_NO_DATA_FOUND') }}</p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      id: '',
      activeTab: 0,
    };
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
      payAnomalyData: 'order/payAnomalyData',
      payAnomalyLoading: 'order/payAnomalyLoading',
    }),
    payAnomalyModifiedData() {
      let modifiedData = [];
      if (this.payAnomalyData.length) {
        modifiedData = this.payAnomalyData.map((anomaly) => {
          const children = [];
          const baseFreightVariance = anomaly.base_freight -
            anomaly.base_freight_threshold;
          const accesorialChargeVariance = anomaly.accessorial_charges.total -
            anomaly.accessorial_charges_threshold;
          Object.keys(anomaly.accessorial_charges).forEach((charge, index) => {
            if (charge !== 'total') {
              children.push({
                id: `${charge}-${index}`,
                key: charge.toUpperCase(),
                actual_value: anomaly.accessorial_charges[charge],
              });
            }
          });
          return {
            order_reference: anomaly.order_reference,
            charges: [
              {
                id: 1,
                key: 'Base Freight',
                actual_value: anomaly.base_freight || 0,
                variance: `${baseFreightVariance < 0 ? '(-)' : '(+)'} ${Math.abs(baseFreightVariance)}`,
              },
              {
                id: 2,
                key: 'Accessorial Charges',
                actual_value: anomaly.accessorial_charges.total,
                variance: `${accesorialChargeVariance < 0 ? '(-)' : '(+)'} ${Math.abs(accesorialChargeVariance)}`,
                children,
              },
              ...(anomaly.payment_value_threshold > 0 ? [{
                id: 3,
                key: 'Payment Value',
                actual_value: (anomaly.charges && anomaly.charges.totalAmount) || 0,
                variance: `${(((anomaly.charges && anomaly.charges.totalAmount) || 0) - anomaly.payment_value_threshold) < 0 ? '(-)' : '(+)'} ${Math.abs(((anomaly.charges && anomaly.charges.totalAmount) || 0) - anomaly.payment_value_threshold)}`,
              }] : []),
            ],
          };
        });
      }
      return modifiedData;
    },
  },
  async created() {
    try {
      this.id = this.$route.params.orderId;
      await this.getPayAnomalyData();
    } catch (err) {
      this.$error({ message: this.$getErr('UNABLE_TO_LOAD') });
    }
  },
  methods: {
    async getPayAnomalyData() {
      try {
        await this.$store.dispatch('order/getPayAnomalyData',
          {
            orderId: this.$route.params.orderId,
            clientId: this.currentClient.id,
          },
        );
      } catch (err) {
        this.$error({ message: this.$getErr('UNABLE_TO_LOAD') });
      }
    },
    async approvePayment() {
      try {
        const result = await this.$store.dispatch('order/approvePayment',
          {
            orderId: this.$route.params.orderId,
            clientId: this.currentClient.id,
          },
        );
        if (result.error) {
          this.$error({ message: this.$getErr('PAYMENT_GENERATION_FAILED') });
        } else {
          this.$successMessage({ message: this.$getSuccess('PAYMENT_GENERATION_SUCCESSFULLY_QUEUED') });
        }
        this.$router.push({ name: 'OutboundIndentsV2' });
      } catch (err) {
        this.$error({ message: this.$getErr('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
